import React, { Fragment } from 'react';
import moment from 'moment';
import enhance from './ViewDeal.enhancer';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import StarRatings from 'react-star-ratings';
import { dealStatuses } from '../../../constants';
import Box from '@material-ui/core/Box';
import LinkText from '../../../components/shared/components/LinkText';
import { getAverageRating } from '../../../helpers/ratingsHelper';

class ViewDeal extends React.Component {
  constructor() {
    super();

    this.initialState = {
      completedDeals: 0,
      deliveredContent: null,
      newRating: 0,
      userRating: 0
    };

    this.state = {
      ...this.initialState
    };
  }

  componentWillMount() {
    // get completed deal count for user
    let dealsQuery;
    if (this.props.currentDeal.user.isCompany) {
      dealsQuery = this.props.firestore
        .collection('deals')
        .where('status', '==', dealStatuses.COMPLETE)
        .where('companyId', '==', this.props.currentDeal.user.uid);
    } else {
      dealsQuery = this.props.firestore
        .collection('deals')
        .where('status', '==', dealStatuses.COMPLETE)
        .where('influencerId', '==', this.props.currentDeal.user.uid);
    }
    dealsQuery.get().then(dealSnapshot => {
      this.setState({
        completedDeals: dealSnapshot.docs.length
      });
    });

    // get rating for the deal
    this.props.firestore
      .collection('ratings')
      .where('dealId', '==', this.props.currentDeal.id)
      .where('rater', '==', this.props.user.uid)
      .get()
      .then(ratingSnapshots => {
        if (ratingSnapshots.docs.length) {
          this.setState({
            currentRating: ratingSnapshots.docs[0].data()
          });
        }
      });

    // get rating for the user
    this.props.firestore
      .collection('ratings')
      .where('ratedUser', '==', this.props.currentDeal.user.uid)
      .get()
      .then(ratingSnapshots => {
        if (ratingSnapshots.docs.length) {
          const ratings = ratingSnapshots.docs.map(rating => rating.data());
          const ratinggg = getAverageRating(ratings);
          this.setState({
            userRating: getAverageRating(ratings)
          });
        }
      });

    // get content for the deal
    this.props.firestore
      .collection('deals')
      .doc(this.props.currentDeal.id)
      .collection('content')
      .get()
      .then(contentSnapshots => {
        if (contentSnapshots.docs.length) {
          const submittedContent = contentSnapshots.docs.map(contentDoc => {
            return contentDoc.data();
          });
          this.setState({
            deliveredContent: submittedContent
          });
        }
      });

    this.setInitialDeal();
  }

  setInitialDeal() {
    const deal = this.props.currentDeal;

    this.setState({
      newDeal: {
        ...deal.currentProposal,
        dueDate: deal.currentProposal.dueDate.toDate()
      }
    });
  }

  getProdCommissionValue() {
    if (this.state.newDeal.productAndCommission) {
      return 'productAndCommission';
    }
    if (this.state.newDeal.commissionOnly) {
      return 'commissionOnly';
    }
    if (this.state.newDeal.productOnly) {
      return 'productOnly';
    }
    return '';
  }

  getPlatformValue() {
    if (this.state.newDeal.platform === 'youtube') {
      return 'youtube';
    }
    if (this.state.newDeal.platform === 'twitch') {
      return 'twitch';
    }
    if (this.state.newDeal.platform === 'instagram') {
      return 'instagram';
    }
    return '';
  }

  changeRating(newRating) {
    this.setState({
      newRating
    });
    //dealId, rater, ratedUser, rating
    this.props.addRatingHandler(
      this.props.currentDeal.id,
      this.props.user.uid,
      this.props.currentDeal.user.uid,
      newRating
    );
  }

  navigateToUserProfile(userId) {
    this.props.history.push(`/user/${userId}/profile`);
  }

  render() {
    const { classes, handleBackToListClick, currentDeal } = this.props;
    const {
      completedDeals,
      deliveredContent,
      currentRating,
      newRating,
      userRating
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <div className={classes.pageTitle} onClick={handleBackToListClick}>
            <Typography variant="h6">
              <ArrowBackIcon className={classes.backButton} />
              Back to Deals
            </Typography>
          </div>
          <Paper className={classes.root}>
            <Grid container>
              <Grid item xs={12}>
                {!currentRating &&
                  !newRating &&
                  (currentDeal.status === dealStatuses.COMPLETE ||
                    currentDeal.status === dealStatuses.DISPUTE_OPENED) && (
                    <div className={classes.ratingContainer}>
                      <Typography
                        display="inline"
                        variant="h6"
                        className={classes.ratingText}
                      >
                        Rate this Deal
                      </Typography>
                      <StarRatings
                        starRatedColor="yellow"
                        changeRating={this.changeRating.bind(this)}
                        numberOfStars={5}
                        name="rating"
                        starDimension="20px"
                        starSpacing="5px"
                        starHoverColor="yellow"
                      />
                    </div>
                  )}
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={6}>
              <Grid item>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  className={classes.userPanel}
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <img
                      src={currentDeal.user.profilePictureUrl}
                      className={classes.circleImage}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ paddingBottom: 0 }}>
                    <Typography variant="h6">
                      <LinkText
                        onClick={() =>
                          this.navigateToUserProfile(currentDeal.user.uid)
                        }
                      >
                        {currentDeal.user.displayName}
                      </LinkText>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                  >
                    <Typography>
                      <StarRatings
                        rating={userRating}
                        starRatedColor="#ffbb44"
                        starDimension="1rem"
                        starSpacing={2}
                        name="rating"
                      />
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                    <Typography color="primary" className={classes.deal}>
                      {completedDeals} Completed Deals
                    </Typography>
                    <Divider />
                  </Grid>
                  <Grid
                    item
                    container
                    justify="center"
                    direction="row"
                    spacing={1}
                  >
                    {currentDeal.user.interests &&
                      currentDeal.user.interests.map(interest => {
                        return (
                          <Grid item>
                            {' '}
                            <Chip label={interest} />
                          </Grid>
                        );
                      })}
                  </Grid>
                </Grid>
                {deliveredContent &&
                  deliveredContent.length > 0 &&
                  deliveredContent.map(content => (
                    <Fragment>
                      <Box mt={4} />
                      <Divider />
                      <Grid>
                        <div className={classes.youtubeVideoUpload}>
                          <iframe
                            className={classes.iframeContainer}
                            src={`https://www.youtube.com/embed/${content.videoId}`}
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          />
                        </div>
                      </Grid>
                    </Fragment>
                  ))}
                {currentRating && (
                  <Fragment>
                    <Grid container direction="column" alignItems="center">
                      <Grid item xs={12}>
                        <Typography>
                          <StarRatings
                            rating={currentRating.rating}
                            starRatedColor="#22c26e"
                            starDimension="1rem"
                            starSpacing={2}
                            name="rating"
                          />
                        </Typography>
                      </Grid>
                    </Grid>
                  </Fragment>
                )}
              </Grid>
              <Grid item sm xs={12} container spacing={4}>
                <Grid spacing={4}>
                  <Grid container item xs={12} direction="column" spacing={4}>
                    <Grid item align="center">
                      <div className={classes.offerTerms}>
                        <Typography variant="h6">Contract Terms</Typography>
                        <Divider />
                      </div>
                    </Grid>
                    <Grid item container direction="row">
                      <Grid item sm={6} className={classes.statsContainer}>
                        {currentDeal.currentProposal.commissionOnly && (
                          <Typography variant="h6">Commission Only</Typography>
                        )}
                        {currentDeal.currentProposal.productAndCommission && (
                          <Typography variant="h6">
                            Product and Commission
                          </Typography>
                        )}
                        {currentDeal.currentProposal.productOnly && (
                          <Typography variant="h6">Product Only</Typography>
                        )}
                        <Typography
                          gutterBottom
                          display="block"
                          variant="body1"
                        >
                          Payment Type
                        </Typography>
                      </Grid>
                      <Grid item sm={6} className={classes.statsContainer}>
                        {currentDeal.currentProposal.platform === 'youtube' && (
                          <Typography variant="h6">Youtube</Typography>
                        )}
                        {currentDeal.currentProposal.platform === 'twitch' && (
                          <Typography variant="h6">Twitch</Typography>
                        )}
                        {currentDeal.currentProposal.platform ===
                          'instagram' && (
                          <Typography variant="h6">Instagram</Typography>
                        )}
                        <Typography
                          gutterBottom
                          display="block"
                          variant="body1"
                        >
                          Platform
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={6}
                        className={classes.statsContainerBottom}
                      >
                        <Typography variant="h6">
                          ${currentDeal.currentProposal.payout.toLocaleString()}
                        </Typography>
                        <Typography
                          gutterBottom
                          display="block"
                          variant="body1"
                        >
                          Commission Amount
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={6}
                        className={classes.statsContainerBottom}
                      >
                        <Typography variant="h6">
                          {moment(
                            currentDeal.currentProposal.dueDate.toDate()
                          ).format('MM/DD/YYYY')}
                        </Typography>
                        <Typography
                          gutterBottom
                          display="block"
                          variant="body1"
                        >
                          Date to be published
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.dealDetails}>
                    <Typography
                      gutterBottom
                      align="left"
                      display="block"
                      variant="h6"
                    >
                      Commission Details
                    </Typography>
                    <div className={classes.details}>
                      <Typography>
                        {currentDeal.currentProposal.commissionDetails}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      gutterBottom
                      align="left"
                      display="block"
                      variant="h6"
                    >
                      Content to be Produced
                    </Typography>
                    <div className={classes.details}>
                      <Typography>
                        {currentDeal.currentProposal.contentDetails}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      gutterBottom
                      align="left"
                      display="block"
                      variant="h6"
                    >
                      Product Deliverable
                    </Typography>
                    <div className={classes.details}>
                      <Typography>
                        {currentDeal.currentProposal.productDeliverableDetails}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

export default enhance(ViewDeal);



// WEBPACK FOOTER //
// ./src/components/deals/view-deal/ViewDeal.js